import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11 20a.968.968 0 0 1-.713-.288A.968.968 0 0 1 10 19v-6L4.2 5.6c-.25-.333-.288-.683-.113-1.05S4.567 4 5 4h14c.433 0 .738.183.913.55.174.367.137.717-.113 1.05L14 13v6a.97.97 0 0 1-.287.712A.968.968 0 0 1 13 20h-2Z" }, null, -1)
  ])))
}
export default { render: render }